import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import Button from './Button';
import WhiteStyledButton from './WhiteStyledButton';

interface NavbarProps {
  title?: string;
}

const Navbar: React.FC<NavbarProps> = ({ title = "Speargrowth" }) => {
  const { handleLinkedInAuth, authState, logOut } = useAuthContext();

  const userName = authState.user
    ? `${authState.user.given_name}`
    : 'New User';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-secondary pt-4 pb-0.5">
      <div className="container mx-auto flex justify-between items-center mb-4">
        <Link to="/" className="text-text hover:text-text text-xl">
          {title}
        </Link>
        <div>
          {authState.isAuthenticated && authState.user ? (
            <WhiteStyledButton
              onClick={logOut}
            >
              Log Out ({userName})
            </WhiteStyledButton>
          ) : (
            <WhiteStyledButton
              onClick={handleLinkedInAuth}
            >
              Login with LinkedIn
            </WhiteStyledButton>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 